import React from 'react';
import { useTheme } from 'styled-components';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import type { DefaultTheme } from 'styled-components';
import {
  StatusBadgeContainer,
  StatusBadgeIcon,
  StatusBadgeLabel,
} from './StatusBadge.styled';

export type StatusBadgeStatus = 'COMPLETED' | 'PARTIAL_SUCCESS' | 'FAILED';

interface StatusBadgeProps {
  status: StatusBadgeStatus;
  'data-testid'?: string;
  className?: string;
}

const getStatusConfig = (status: StatusBadgeStatus, theme: DefaultTheme) => {
  switch (status) {
    case 'COMPLETED':
      return {
        label: 'Completed',
        icon: 'uil uil-check-circle',
        color: theme.atlas.semantic.color.action.primary.onPrimary,
      };
    case 'PARTIAL_SUCCESS':
      return {
        label: 'Partial success',
        icon: 'uil uil-exclamation-triangle',
        color: theme.atlas.semantic.color.type.default,
      };
    case 'FAILED':
      return {
        label: 'Failed',
        icon: 'uil uil-times-circle',
        color: theme.atlas.semantic.color.action.primary.onPrimary,
      };
  }
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  'data-testid': dataTestId,
  className,
}) => {
  const theme = useTheme();
  const config = getStatusConfig(status, theme);

  return (
    <StatusBadgeContainer
      $status={status}
      data-testid={dataTestId || 'status-badge'}
      className={className}
    >
      <StatusBadgeIcon data-testid={`${dataTestId || 'status-badge'}-icon`}>
        <StyledIcon className={config.icon} size="14px" color={config.color} />
      </StatusBadgeIcon>
      <StatusBadgeLabel data-testid={`${dataTestId || 'status-badge'}-label`}>
        {config.label}
      </StatusBadgeLabel>
    </StatusBadgeContainer>
  );
};
